import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/landing'
  },
  {
    path: '/landing',
    name: 'Landing',
    component: () => import('@/views/login/landing_page.vue'),
    meta: { title: '首页', noAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/login.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/reg',
    name: 'Reg',
    component: () => import('@/views/login/reg.vue'),
    meta: { title: '注册', noAuth: true }
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/index/index.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/trade',
    name: 'Trade',
    component: () => import('@/views/trade/trade.vue'),
    meta: { title: '交易' }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/account/account.vue'),
    meta: { title: '账户' }
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/mine/mine.vue'),
    meta: { title: '我的' }
  },
  {
    path: '/mine/verified',
    name: 'Verified',
    component: () => import('@/views/mine/verified.vue'),
    meta: { title: '实名认证' }
  },
  {
    path: '/mine/set_account',
    name: 'SetAccount',
    component: () => import('@/views/mine/set_account.vue'),
    meta: { title: '账户安全' }
  },
  {
    path: '/mine/pwd_login',
    name: 'PwdLogin',
    component: () => import('@/views/mine/pwd_login.vue'),
    meta: { title: '修改登录密码' }
  },
  {
    path: '/mine/pwd_pay',
    name: 'PwdPay',
    component: () => import('@/views/mine/pwd_pay.vue'),
    meta: { title: '修改支付密码' }
  },
  {
    path: '/mine/msg_view',
    name: 'MsgView',
    component: () => import('@/views/mine/msg_view.vue'),
    meta: { title: '详情' }
  },
  {
    path: '/mine/recharge_record',
    name: 'RechargeRecord',
    component: () => import('@/views/mine/recharge_record.vue'),
    meta: { title: '充值记录' }
  },
  {
    path: '/mine/recharge',
    name: 'Recharge',
    component: () => import('@/views/mine/recharge.vue'),
    meta: { title: '充值' }
  },
  {
    path: '/mine/cash',
    name: 'Cash',
    component: () => import('@/views/mine/cash.vue'),
    meta: { title: '提现' }
  },
  {
    path: '/mine/cash_record',
    name: 'CashRecord',
    component: () => import('@/views/mine/cash_record.vue'),
    meta: { title: '提现记录' }
  },
  {
    path: '/mine/history_entrust',
    name: 'HistoryEntrust',
    component: () => import('@/views/mine/history_entrust.vue'),
    meta: { title: '历史委托' }
  },
  {
    path: '/mine/bill',
    name: 'Bill',
    component: () => import('@/views/mine/bill.vue'),
    meta: { title: '账单' }
  },
  {
    path: '/mine/help',
    name: 'Help',
    component: () => import('@/views/mine/help.vue'),
    meta: { title: '帮助中心' }
  },
  {
    path: '/mine/add_bank_card',
    name: 'AddBankCard',
    component: () => import('@/views/mine/add_bank_card.vue'),
    meta: { title: '添加银行卡' }
  },
  {
    path: '/mine/add_alipay',
    name: 'AddAlipay',
    component: () => import('@/views/mine/add_alipay.vue'),
    meta: { title: '绑定支付宝' }
  },
  {
    path: '/mine/alipay',
    name: 'Alipay',
    component: () => import('@/views/mine/alipay.vue'),
    meta: { title: '绑定钱包地址' }
  },
  {
    path: '/mine/bank_card_list',
    name: 'BankCardList',
    component: () => import('@/views/mine/bank_card_list.vue'),
    meta: { title: '银行卡列表' }
  },
  {
    path: '/mine/service',
    name: 'Service',
    component: () => import('@/views/mine/service.vue'),
    meta: { title: '在线客服' }
  },
  {
    path: '/mine/news',
    name: 'News',
    component: () => import('@/views/mine/news.vue'),
    meta: { title: '新闻资讯' }
  },
  {
    path: '/mine/news_detail',
    name: 'NewsDetail',
    component: () => import('@/views/mine/news_detail.vue'),
    meta: { title: '新闻详情' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const uid = localStorage.getItem('uid')
  const isLoginPath = to.path.includes('/login')
  
  if (!uid && !isLoginPath && !to.meta.noAuth) {
    next('/login')
  } else {
    next()
  }
})

export default router